import { Flex, Typography } from 'antd';
import { PropsWithChildren } from 'react';

import styles from './index.module.scss';

export const SelectedItemsFooter = ({
  mobile = false,
  children,
}: PropsWithChildren<{ mobile?: boolean }>) => {
  return (
    <Flex className={mobile ? '' : styles.container}>
      <Typography.Text italic className={styles.content}>
        {children}
      </Typography.Text>
    </Flex>
  );
};
